import { nanoid } from 'nanoid';

import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { PetitionGuidesDataQuery, PetitionGuidesDataQueryVariables } from './api.graphql';
import { PetitionGuidesData } from './api.graphql';

export type PetitionGuidesPageData = {
	article: NonNullable<PetitionGuidesDataQuery['article']>;
	articles: NonNullable<PetitionGuidesDataQuery['articles']>;
	coreArticles: NonNullable<PetitionGuidesDataQuery['coreArticles']>;
	aiSapId: string;
};

export async function getPetitionGuidesPageData(
	{ gql: { fetch } }: UtilityContext,
	slug: string,
): Promise<PetitionGuidesPageData> {
	const { data } = await fetch<PetitionGuidesDataQuery, PetitionGuidesDataQueryVariables>({
		query: PetitionGuidesData,
		variables: {
			slug,
		},
		rejectOnError: true,
	});

	if (!data.article) {
		throw new NotFoundError();
	}

	return {
		article: data.article,
		coreArticles: data.coreArticles,
		articles: data.articles,
		aiSapId: nanoid(),
	};
}
